module.exports = __webpack_public_path__ + "static/media/volunteer-john.0e710b89.jpg";